<template>
  <div>
    <div class="col-12 lg:col-12 px-0">
      <Toolbar class="mb-2">
        <template #end>
          <Button
            label="Nuevo"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            @click="agregarInsumo"
          />
          <!-- <Button v-show="selectTipoReporte && selectTipoReporte.id>0" label="Exportar a Excel" icon="pi pi-download" class="p-button-help" @click="exportar($event)"></Button> -->
        </template>
      </Toolbar>
    </div>

    <DataTable
      :value="lstEquipos"
      v-model:expandedRows="expandedRows"
      dataKey="Id_producto"
      ref="dt"
      v-model:filters="filters"
      :globalFilterFields="['Producto', 'Marca', 'Modelo']"
      :loading="loading"
      :paginator="true"
      :rows="20"
      responsiveLayout="scroll"
    >
      <template #header>
        <div class="table-header">
          <h5>Insumos</h5>
          <span
            >Número de artículos {{ lstEquipos ? lstEquipos.length : 0 }}</span
          >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              type="text"
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>
      <Column :expander="true" headerStyle="width: 3rem" />
      <Column field="Producto" header="PRODUCTO" sortable>
        <template #body="{data}">
            {{ data.Producto }} <span v-if="data.PENAEC"><br><b>PNAEC:</b> {{ data.Numero_penaec }}</span> <span v-if="data.Programa_mantenimiento"><br><b>Programa mantenimiento:</b> {{ data.Programa_mantenimiento_anio }}</span>
        </template>
      </Column>
      <Column field="Marca" header="MARCA" sortable></Column>
      <Column field="Modelo" header="MODELO" sortable></Column>
      <Column
        field="Url_imagen"
        header="IMAGEN"
        :sortable="false"
        style="min-width: 12rem"
      >
        <template #body="slotProps">
          <Image :src="concatenarImagen(slotProps.data.Url_imagen)" alt="Image" :width="slotProps.data.Url_imagen==''?'50':'100'" />
        </template>
      </Column>
      <Column field="Activo" header="ESTATUS" sortable>
        <template #body="slotProps">
          <span class="status-activo" v-show="slotProps.data.Activo"> ACTIVO </span>
          <span class="status-inactivo" v-show="!slotProps.data.Activo"> INACTIVO </span>
        </template>
      </Column>
      <Column field="CantidadDisponibles" header="Disponibles" sortable></Column>
      <Column :exportable="false">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success"
            @click="edit(slotProps.data)"
          />
          <Button
            style="margin-left: 8px"
            icon="pi pi-times"
            class="p-button-rounded p-button-danger"
            @click="borrar(slotProps.data)"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        <Card>
          <template #content>
            <div class="grid">
              <div class="col-6">
                <div class="grid">
                  <div class="col title">Salida individual</div>
                  <div class="col data">
                    {{ slotProps.data.Salida_individual ? "Sí" : "No" }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="grid">
                  <div class="col title">FECHA DE CREACIÓN</div>
                  <div class="col data">
                    {{ getFechaWCF(slotProps.data.Fecha_creacion) }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="grid">
                  <div class="col title">DESCRIPCIÓN</div>
                  <div class="col data">
                    {{ slotProps.data.Descripcion }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Card>
      </template>
      <template #footer>
        Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
      </template>
    </DataTable>

    <Dialog
      :style="{ width: '600px' }"
      :visible="showAgregar"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>{{ modoEdicion }} insumo</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="Producto">Producto</label>
          <InputText
            autocomplete="off"
            id="Producto"
            v-model.trim="equipo.Producto"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.Producto }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.Producto"
            >El producto es requerido.</small
          >
        </div>
        <div class="p-field col">
          <label for="Url_imagen">Url imagen</label>
          <FileUpload
            ref="fil"
            mode="basic"
            :maxFileSize="1000000"
            :customUpload="true"
            invalidFileSizeMessage="El archivo debe ser de máximo 1MB"
            chooseLabel="Cargar Imagen"
            uploadLabel="Subir"
            accept="image/*"
          />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="marca">Marca</label>
          <InputText
            autocomplete="off"
            id="marca"
            v-model.trim="equipo.Marca"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.Marca }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.Marca"
            >La marca es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="modelo">Modelo</label>
          <InputText
            autocomplete="off"
            id="modelo"
            v-model.trim="equipo.Modelo"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.Modelo }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.Modelo"
            >El modelo es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="obs">Descripción</label>
          <Textarea
            autocomplete="off"
            id="obs"
            v-model.trim="equipo.Descripcion"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <!-- <div class="p-field col">
            <div class="p-field-checkbox">
              <Checkbox
                id="diag"
                name="diag"
                :binary="true"
                v-model="equipo.DIAG"
              />
              <label for="diag">DIAG</label>
            </div>
          </div> -->
        <div class="col-12">
          <div class="grid flex align-items-center h-4rem">
              <div class="col-6">
                  <label for="PENAEC" class="pr-2">¿Es PNAEC?</label>
                  <Checkbox
                    id="PENAEC"
                    name="PENAEC"
                    :binary="true"
                    v-model="equipo.PENAEC"
                  />
              </div>
              <div class="p-field col-6">
                <label for="Numero_penaec"></label>
                  <InputText v-if="equipo.PENAEC"
                    type="text"
                    id="Numero_penaec"
                    name="Numero_penaec"
                    v-model="equipo.Numero_penaec"
                    placeholder="Numero de PNAEC"
                    maxlength="10"
                    :class="{ 'p-invalid': submitted && equipo.PENAEC && !equipo.Numero_penaec }"
                  />
              </div>
          </div>
        </div>
        <div class="col-12">
          <div class="grid flex align-items-center border-top-1 border-bottom-1 border-300 h-4rem">
              <div class="col-6">
                  <label for="Programa_mantenimiento" class="pr-2">¿Es programa de mantenimiento?</label>
                  <Checkbox
                    id="Programa_mantenimiento"
                    name="Programa_mantenimiento"
                    :binary="true"
                    v-model="equipo.Programa_mantenimiento"
                  />
              </div>
              <div class="p-field col-6">
                <label for="Programa_mantenimiento_anio"></label>
                  <Calendar v-if="equipo.Programa_mantenimiento"
                    id="Programa_mantenimiento_anio"
                    name="Programa_mantenimiento_anio"
                    v-model="equipo.Programa_mantenimiento_anio"
                    placeholder="Año del programa"
                    view="year" dateFormat="yy" 
                    :class="{ 'p-invalid': submitted && equipo.Programa_mantenimiento && !equipo.Programa_mantenimiento_anio }"
                    :pt="{
                      input : {
                          maxlength: 10
                      }
                    }"

                  />
              </div>
          </div>
        </div>
        <div class="p-field col">
          <div class="p-field-checkbox">
            <Checkbox
              id="Activo"
              name="Activo"
              :binary="true"
              v-model="equipo.Activo"
            />
            <label for="Activo"> Activo</label>
          </div>
        </div>
        <div class="p-field col">
          <div class="p-field-checkbox">
            <Checkbox
              id="Capitalizable"
              name="Capitalizable"
              :binary="true"
              v-model="equipo.Capitalizable"
            />
            <label for="Capitalizable"> Bien capitalizable o requiere CBM5</label>
          </div>
        </div>
        <div class="p-field col">
          <div class="p-field-checkbox">
            <Checkbox
              id="Salida_individual"
              name="Salida_individual"
              :binary="true"
              v-model="equipo.Salida_individual"
            />
            <label for="Salida_individual"> Salida Individual</label>
          </div>
        </div>
        <div class="col-12">
          <InlineMessage v-show="mensajes" >{{ mensajes }}</InlineMessage >
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarInsumo"
        />
      </template>
    </Dialog>

    <Dialog
      :style="{ width: '650px' }"
      v-model:visible="verModelo"
      :modal="true"
      class="p-fluid"
      :closable="true"
    >
      <img :src="img" />
    </Dialog>
  </div>
</template>

<script>
import SProductos from "../service/Productos";
import { FilterMatchMode } from "primevue/api";
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      Activo: false,
      Capitalizable: false,
      Salida_individual: false,
      lstUnidades: [],
      selectedUnidadFiltro: null,
      lstEquipos: null,
      lstEquiposO: null,
      lstTipos: null,
      lstModalidades: null, //['N/A','CONFIGURABLE','PLANO','SERVICIOS'],
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      filter: null,
      loading: true,
      submitted: false,
      showAgregar: false,
      equipoEdited: null,
      modoEdicion: "",
      expandedRows: [],
      equipo: {},
      verModelo: false,
      img: "",
      mensajes:"",
    };
  },
  created() {
    this.getInsumos();
  },
  methods: {
    concatenarImagen(urlImagen){
      if(urlImagen != "")
          return this.getUrlServicios + urlImagen.replace("~/","");
      else
          return "../assets/sinImagen.png";
    },
    getInsumos() {
      var t = this;
      var CSrvr = new SProductos();
      t.loading = true;

      CSrvr.getInsumos(t)
        .then((res) => {
          t.lstEquipos = res; //res.filter((item) => item.Activo);
          t.loading = false;
        })
        .catch(function (error) {
          console.error("Error:", error);
          t.loading = false;
        });
    },

    getFechaWCF(fecha, hora) {
      if (fecha) {
        var millis = fecha
          .replace("/Date(", "")
          .replace("/", "")
          .replace(")", "");

        millis = millis * 1;

        if (millis > 0) {
          var mfecha = new Date(millis);

          var res =
            mfecha.getDate() < 10 ? "0" + mfecha.getDate() : mfecha.getDate();
          res += "/";
          res +=
            mfecha.getMonth() + 1 < 10
              ? "0" + (mfecha.getMonth() + 1)
              : mfecha.getMonth() + 1;
          res += "/";
          res += mfecha.getFullYear();

          if (hora) {
            res += " ";
            res += mfecha.getHours();
            res += ":";
            res +=
              mfecha.getMinutes() < 10
                ? "0" + mfecha.getMinutes()
                : mfecha.getMinutes();
          }

          return res;
        } else {
          return "N/D";
        }
      }
    },

    expandAll() {
      this.expandedRows = this.lstEquipos.filter((e) => e.Id_producto);
    },
    collapseAll() {
      this.expandedRows = null;
    },
    forzarUpdate() {
      this.$forceUpdate();
    },
    verImg(i) {
      this.verModelo = true;
      this.img = i;
    },
    agregarInsumo() {
      this.submitted = false;
      this.showAgregar = true;
      this.modoEdicion = "Agregar";
      this.mensajes = "";
      this.equipo.Descripcion = "";
      // this.equipo.tUnidad = {};
      //this.reiniciaEquipo();
    },
    cancelarDialogo() {
      this.submitted = false;
      this.showAgregar = false;
      this.modoEdicion = "";
      this.equipo = {};
      this.mensajes = "";
      //this.reiniciaEquipo();
    },
    edit(obj) {
      this.equipo = { ...obj };
      this.showAgregar = true;
      this.modoEdicion = "Editar";
      // this.equipo.tUnidad = {};
    },
    borrar(obj) {
      var t = this;      
      var ok = confirm("¿Quiere eliminar este artículo?");
      if (ok) {
        var val = obj;
        var ctlSvr = new SProductos();
        obj.Activo = false;
        ctlSvr.updateInsumo(t, val).then(() => {
          t.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Insumo eliminado correctamente",
            life: 3000,
          });
          t.getInsumos();
        });
      }
    },

    guardarInsumo() {
      var t = this;
      var fileByteArray = [];
      var file = null;
      var newFileName = null;
      this.submitted = true;
      

      if (
        !t.equipo ||
        !t.equipo.Producto ||
        !t.equipo.Marca ||
        !t.equipo.Modelo ||
        (t.equipo.PENAEC && !t.equipo.Numero_penaec) ||
        (t.equipo.Programa_mantenimiento && !t.equipo.Programa_mantenimiento_anio)
      ) {
        t.mensajes = "Algunos campos faltantes son obligatorios";
        return;
      }

      t.equipo.Activo = true;

      let now = new Date();
        let timestamp = "/Date(" + now.getTime() + ")/";
        let obj = {
          Id_producto: t.equipo.Id_producto,
          Producto: t.equipo.Producto,
          Marca: t.equipo.Marca,
          Modelo: t.equipo.Modelo,
          Salida_individual: t.equipo.Salida_individual,
          Descripcion: t.equipo.Descripcion,
          Url_imagen: t.equipo.Url_imagen,
          Activo: t.equipo.Activo,
          Capitalizable: t.equipo.Capitalizable,
          Fecha_creacion: timestamp,
          PENAEC: t.equipo.PENAEC ?? false,
          Numero_penaec: t.equipo.PENAEC && t.equipo.Numero_penaec? t.equipo.Numero_penaec : "",
          Programa_mantenimiento: t.equipo.Programa_mantenimiento?? false,
          Programa_mantenimiento_anio: t.equipo.Programa_mantenimiento ? t.equipo.Programa_mantenimiento_anio instanceof Date && !isNaN(t.equipo.Programa_mantenimiento_anio) ? t.equipo.Programa_mantenimiento_anio?.getFullYear()?? "" : t.equipo.Programa_mantenimiento_anio : null,
        };
        if (t.$refs.fil.files.length > 0) {
          file = t.$refs.fil.files[0];
          newFileName = file.name;
          var ext = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
          if (ext.length > 0 && ext.length <= 4) {
            if (file.size <= 1000000) {
              var reader = new FileReader();
              reader.readAsArrayBuffer(file);
              reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                  var arrayBuffer = evt.target.result,
                    array = new Uint8Array(arrayBuffer);
                  for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                  }
                  newFileName = newFileName.replace(" ", "");
                  newFileName = newFileName.replace("_", "");

                  obj.ImagenProducto = {
                    fileName: newFileName,
                    fileBytes: fileByteArray,
                  };

                  t.sendRequest(t,obj);
                }
              };
            }
          }
        }else{
          t.sendRequest(t,obj);
        }
    },
    sendRequest(t, obj){
      var CSrvr = new SProductos();
        if (t.modoEdicion == "Agregar") {
          CSrvr.addInsumo(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Insumo agregado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.getInsumos();
          });
        } else {
          CSrvr.updateInsumo(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Insumo editado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.getInsumos();
          });
        }
    }
  },
  computed:{
    ...mapGetters(['getUrlServicios','getUsuarioLogueado']),  
  },       
};
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.3px;
  margin-right: 10px;
  letter-spacing: 0.5px;
}
.product-image {
  width: 100px;
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); */
}
</style>
